require('core-js/stable')
require('regenerator-runtime/runtime')
require('intersection-observer')
require('object-fit-images')()
require('whatwg-fetch')
